import './assets/Css/Style.css';
import './assets/Css/Responsive.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from './Components/Pages/Home';
import About from './Components/Pages/About';
import Contact from './Components/Pages/Contact';
import Services from './Components/Pages/Services';
import Price from './Components/Pages/Price';
import Projects from './Components/Pages/Projects';
import Team from './Components/Pages/Team';
import Testimonials from './Components/Pages/Testimonials';
import FAQ from './Components/Pages/FAQ';
import Blog from './Components/Pages/Blog';
import Comingsoon from './Components/Pages/Comingsoon';
import Error from './Components/Pages/Error';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "About",
    element: <About />,
  },
  {
    path: "Contact",
    element: <Contact />,
  },
  {
    path: "service",
    element: <Services />,
  },
  {
    path: "pricing",
    element: <Price />,
  },
  {
    path: "Project",
    element: <Projects />,
  },
  {
    path: "team",
    element: <Team />,
  },
  {
    path: "testimonial",
    element: <Testimonials />,
  },
  {
    path: "faq",
    element: <FAQ />,
  },
  {
    path: "blog",
    element: <Blog />,
  },
  {
    path: "coming_soon",
    element: <Comingsoon />,
  },
  {
    path: "404",
    element: <Error />,
  },
]);

function App() {
  return (
    <>
      {/* <Home /> */}
      {/* <About /> */}
      {/* <Contact /> */}
      {/* <Services /> */}
      {/* <Price /> */}
      {/* <Projects /> */}
      {/* <Team /> */}
      {/* <Testimonials /> */}
      {/* <FAQ /> */}
      {/* <Blog /> */}
      {/* <Comingsoon /> */}
      {/* <Error /> */}
      <RouterProvider router ={router} />
    </>
  );
}

export default App;
